import { theme } from '@insight-health-ai/roseate/theme';
import { EncounterChatCompletionStatus } from 'src/models';

type ChatCompletionStatusProps = {
  status: EncounterChatCompletionStatus;
};

const statusConfigMap: Record<
  Lowercase<EncounterChatCompletionStatus>,
  {
    color: string;
    label: string;
  }
> = {
  new: {
    color: '#5a8dda',
    label: 'Not Started',
  },
  inprogress: {
    color: '#ff6f00',
    label: 'In Progress',
  },
  'summary inprogress': {
    color: '#ff6f00',
    label: 'Summary In Progress',
  },
  completed: {
    color: theme.colors.success,
    label: 'Completed',
  },
  undeliverable: {
    color: theme.colors.error,
    label: 'Undeliverable',
  },
  unavailable: {
    color: '#4a5565',
    label: 'Unavailable',
  },
  processed: {
    color: '#4d38ca',
    label: 'Processed',
  },
};

export const ChatCompletionStatus = ({ status }: ChatCompletionStatusProps) => {
  const statusKey =
    status.toLowerCase() as Lowercase<EncounterChatCompletionStatus>;

  const { color, label } = statusConfigMap[statusKey];

  return (
    <div className="flex items-center gap-1 text-sm" style={{ color }}>
      {label}
    </div>
  );
};
